/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormatMetadata
 */
export interface FormatMetadata {
    /**
     * 
     * @type {number}
     * @memberof FormatMetadata
     */
    readonly width?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormatMetadata
     */
    readonly height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormatMetadata
     */
    readonly framerateFloat?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FormatMetadata
     */
    readonly framerate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FormatMetadata
     */
    readonly duration?: number | null;
}

export function FormatMetadataFromJSON(json: any): FormatMetadata {
    return FormatMetadataFromJSONTyped(json, false);
}

export function FormatMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormatMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'framerateFloat': !exists(json, 'framerate_float') ? undefined : json['framerate_float'],
        'framerate': !exists(json, 'framerate') ? undefined : json['framerate'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
    };
}

export function FormatMetadataToJSON(value?: FormatMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


